import { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollReveal from '@/components/base/ScrollReveal';
import ParticleBackground from '@/components/base/ParticleBackground';
import { newsItems } from '@/pages/news/data';

export default function NewsDetail() {
  const { id } = useParams();

  const news = useMemo(() => {
    const parsedId = Number(id);
    return newsItems.find((item) => item.id === parsedId);
  }, [id]);

  if (!news) {
    return (
      <div className="ui-page">
        <Navbar />
        <main className="pt-28 px-4 md:px-8 lg:px-12">
          <div className="max-w-screen-md mx-auto text-center py-20">
            <h1 className="font-heading text-3xl text-primary-500 mb-4">动态不存在</h1>
            <p className="text-secondary-400 mb-8">该内容可能已下线或链接有误。</p>
            <Link to="/news" className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-primary-500 text-background-950 text-sm font-medium">
              返回新闻动态
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="ui-page">
      <Navbar />
      <main className="pt-20">
        <section className="relative py-16 md:py-24 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-background-900/40 to-transparent z-[1]"></div>
          <ParticleBackground compact />
          <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
            <div className="max-w-screen-xl mx-auto">
              <ScrollReveal>
                <div className="mb-10">
                  <Link to="/news" className="inline-flex items-center gap-2 text-secondary-400 hover:text-primary-500 transition-colors mb-5">
                    <i className="ri-arrow-left-line"></i>
                    返回新闻目录
                  </Link>
                  <div className="flex items-center gap-3 mb-4">
                    <span className="px-3 py-1 rounded-full bg-accent-500/15 border border-accent-500/20 text-accent-300 text-xs font-medium whitespace-nowrap">{news.category}</span>
                    {news.tag && <span className="px-2 py-1 rounded-full bg-primary-500/15 border border-primary-500/20 text-primary-400 text-xs font-medium whitespace-nowrap">{news.tag}</span>}
                    <span className="text-secondary-500 text-xs">{news.date}</span>
                  </div>
                  <h1 className="ui-title-glow font-heading text-3xl md:text-5xl font-bold text-primary-500 mb-5">{news.title}</h1>
                  <p className="text-secondary-300 leading-relaxed max-w-4xl">{news.excerpt}</p>
                </div>
              </ScrollReveal>

              <ScrollReveal>
                <div className="ui-panel rounded-2xl overflow-hidden mb-8">
                  <img src={news.cover} alt={news.title} className="w-full h-auto object-cover" />
                </div>
              </ScrollReveal>

              <ScrollReveal>
                <article className="ui-panel rounded-2xl p-6 md:p-8 space-y-5">
                  {news.content.map((paragraph) => (
                    <p key={paragraph} className="text-secondary-300 text-sm md:text-base leading-relaxed">
                      {paragraph}
                    </p>
                  ))}
                </article>
              </ScrollReveal>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

